import WixDataSchemas from './wix-data-schemas';
export var createDataSchemasClientForBrowser = function (httpClient, signedInstance, gridAppId, options) {
    return new WixDataSchemas(httpClient, signedInstance, gridAppId, options);
};
//# sourceMappingURL=browser.js.map